// Core
import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// Styles
import "./styles.scss";

//Redux
import {
  getPastAssessment_USER,
  getPendingtAssessment_USER,
} from "../../../../Redux/Slices/User/userSlice";
import { setReportId } from "../../../../Redux/Slices/User/reportSlice";

//Component
import MainLayout from "Layouts/Main";
import Assessment from "Components/ScheduledAssesment";
import Button from "Components/Button";
import moment from "moment-timezone";
import PastAssessmentCard from "Components/PastAssessmentCard";
import InstructionsModalForUser from "../../../../Components/InstructionsModal/InstructionsModalForUser";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { f } from "html2pdf.js";

const PreAssessment = () => {
  const [data, setData] = useState([]);
  const [userName, setUserName] = useState("");
  const [submitName, setSubmitName] = useState("");
  const [preAssessmentData, setPreAssessmentData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [showInstructions, setShowInstructions] = useState(false);
  const [selectedAssessmentId, setSelectedAssessmentId] = useState(null);
  const [selectedAssessment, setSelectedAssessment] = useState(null);

  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.user.isLoading);
  const navigate = useNavigate();

  // Table Data
  useEffect(() => {
    getPastAssessmentUsers(currentPage);
  }, []);

  const getPastAssessmentUsers = (page) => {
    dispatch(
      getPastAssessment_USER({
        page: page,
        callBack: getAllPastAssessmentUser,
      })
    );
  };

  const getAllPastAssessmentUser = (data) => {
    setTotalPages(data?.data?.pageMeta?.totalPages);
    setData(data?.data?.data_list);
    setUserName(data?.userName);
  };

  useEffect(() => {
    getPreAssessmentUsers();
  }, []);
  const getPreAssessmentUsers = () => {
    dispatch(
      getPendingtAssessment_USER({
        callBack: getPendingAssessmentUsers,
      })
    );
  };

  const getPendingAssessmentUsers = (data) => {
    setPreAssessmentData(data?.data?.datas || []);
    setSubmitName(data?.data?.userName);
  };

  const handleOnClick = (assessment) => {
    setSelectedAssessmentId(assessment?.backlog_id);
    setSelectedAssessment(assessment); // Store the full object
    setShowInstructions(true);
  };
  const handleViewReport = (id) => {
    dispatch(setReportId(id));
    navigate(`/`, {
      state: {
        activeComponent: "pastReports",
      },
    });
  };

  const handleViewAssessment = (id, name) => {
    navigate(`/pre-assessment/view/${id}`, {state : {name, id}});
  };

 const handleContinue = () => {
  if (!selectedAssessment) return;
  setShowInstructions(false);
  navigate(`/pre-assessment/questions/${selectedAssessmentId}`, {
    state: {
      companyName: selectedAssessment?.assessment_backlog?.company_name,
      assessmentId: selectedAssessment?.backlog_id,
      completionPercentage: selectedAssessment?.percentage,
    },
  });
};


  return (
    <MainLayout>
      <InstructionsModalForUser
        isOpen={showInstructions}
        onClose={() => setShowInstructions(false)}
        onContinue={handleContinue}
        Button={Button}
      />
      <div className="pre-assessment-root-container">
        <h1 className="pre-assessment-heading">Pre-Assessment</h1>
        <h1 className="pending-assessment-subheading">Ongoing Assessments</h1>
        <div className="pending-assessement-ongoing-container">
          {isLoading === "loading" ? (
            <Skeleton height={200} />
          ) : preAssessmentData && preAssessmentData.length > 0 ? (
            preAssessmentData.map((assessment, index) => (
              <Assessment
                key={index}
                labeltype={1}
                assessmentName={assessment?.assessment_name}
                status={assessment?.assessment_status}
                plannedDate={
                  assessment?.startDate
                    ? moment(assessment?.startDate).tz("Asia/Kolkata").format("DD-MM-YYYY")
                    : "-"
                }
                dueDate={
                  assessment?.dueDate
                    ? moment(assessment?.dueDate).tz("Asia/Kolkata").format("DD-MM-YYYY")
                    : "-"
                }
                referenceName={assessment?.assessment_backlog?.reference_name || ""}
                headingName={assessment?.heading_name}
                backlog_id={assessment?.backlog_id}
                buttonTitle="Continue Pre-Assessment"
                assessorName={
                  assessment?.assessment_backlog?.users?.assessor_name
                }
                completionPercentage={assessment?.percentage || 0}
                handleOnclick={() => handleOnClick(assessment)} // Pass individual assessment
                submittedName={submitName}
              />
            ))
          ) : (
            <>
              <h5 className="text-center">No Ongoing Assessment Available</h5>
            </>
          )}
        </div>
        <div className="my-5">
          <h1 className="pending-assessment-subheading">Past Assessments</h1>
          {isLoading === "loading"
            ? // Skeleton loader for past assessments while loading
              Array(3)
                .fill()
                .map((_, index) => (
                  <div key={index} className="skeleton-container">
                    <Skeleton height={180} style={{ marginBottom: "20px" }} />
                  </div>
                ))
            : data?.map((item) => {
                return (
                  <PastAssessmentCard
                    key={item.assignment_id}
                    data={item}
                    assessmentName={item?.assessment_name}
                    assessmentSubmittedDate= {item?.submitted_at ? moment(item?.submitted_at).tz("Asia/Kolkata").format(
                      "DD-MM-YYYY"
                    ) : "-"}
                    referenceName={item?.assessment_backlog?.reference_name}
                    assessorName={item.assessment_backlog?.users?.assessor_name}
                    userName={userName}
                    handleViewReport={() => handleViewReport(item.backlog_id)}
                    handleViewAssessment={() => handleViewAssessment(item.backlog_id, item?.assessment_name)}
                    approvalStatus={item.assessment_backlog?.approval_status}
                    showViewReport={true}
                    showViewRecommendations={false}
                  />
                );
              })}
        </div>
      </div>
    </MainLayout>
  );
};

export default PreAssessment;
